import { CustomAvatar } from "@/components/common/CustomAvatar";
import type { ChatRoomType } from "@/lib/humhub-api/types";
import { cn } from "@/lib/utils";

interface ChatRoomAvatarProps {
  title?: string;
  displayTitle?: string;
  imageUrl?: string;
  type?: ChatRoomType;
  size?: number;
  className?: string;
}

export const ChatRoomAvatar: React.FC<ChatRoomAvatarProps> = ({
  title,
  displayTitle,
  imageUrl,
  size = 32,
  className,
}) => {
  const resolvedTitle = displayTitle ?? title;
  return (
    <CustomAvatar
      name={resolvedTitle ?? title ?? "Chat"}
      imageUrl={imageUrl}
      size={size}
      roundedFull
      className={cn(className)}
    />
  );
};
